import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
interface CreateWorkspaceModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CreateWorkspaceModal({
  isOpen,
  onClose
}: CreateWorkspaceModalProps) {
  const {
    createWorkspace
  } = useWorkspace();
  const [formData, setFormData] = useState({
    name: '',
    region: ''
  });
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createWorkspace(formData);
    onClose();
    setFormData({
      name: '',
      region: ''
    });
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-218">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-219">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} data-id="element-220" />

        <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-lg" data-id="element-221">
          <div className="px-4 py-5 sm:p-6" data-id="element-222">
            <div className="flex items-center justify-between mb-5" data-id="element-223">
              <h3 className="text-lg font-medium leading-6 text-gray-900" data-id="element-224">
                Create New Workspace
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-225">
                <X className="h-6 w-6" data-id="element-226" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-227">
              <div data-id="element-228">
                <label className="block text-sm font-medium text-gray-700" data-id="element-229">
                  Workspace Name
                </label>
                <input type="text" required placeholder="e.g. North America Team" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} data-id="element-230" />
              </div>

              <div data-id="element-231">
                <label className="block text-sm font-medium text-gray-700" data-id="element-232">
                  Region
                </label>
                <input type="text" required placeholder="e.g. NA, EMEA, APAC" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.region} onChange={e => setFormData({
                ...formData,
                region: e.target.value
              })} data-id="element-233" />
              </div>

              <div className="mt-5 sm:mt-6" data-id="element-234">
                <button type="submit" className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm" data-id="element-235">
                  Create Workspace
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
}